import { useSelector } from 'react-redux';

import Head from 'next/head';

import { useFeature } from '@atc/features';
import { useOptimizelySnippet } from '@atc/optimizely-toolkit';

import currentPageNameDuck from '@/ducks/currentPageNameDuck';

export default function OptimizelySnippetLoader({ query = {}, url }) {

    const [enableThirdParty] = useFeature('thirdparty');
    const pageName = useSelector(currentPageNameDuck.selectors.getDuckState);

    const [optimizelySnippet, preloadSnippet] = useOptimizelySnippet({
        pageName,
        query,
        thirdPartyEnabled: enableThirdParty,
        url,
    });

    return optimizelySnippet && (
        <Head>
            {preloadSnippet && (
                <link
                    rel="preload"
                    href={optimizelySnippet}
                    as="script"
                    key="optimizelySnippetPreload"
                />
            )}
            <script
                async={false}
                key="optimizelySnippet"
                src={optimizelySnippet}
                type="text/javascript"
            />
        </Head>
    );
}
